// extracted by mini-css-extract-plugin
export var phone = "_1b-0";